{
	"showButtonTitle": "Mostrar",
	"hideButtonTitle": "Ocultar"
}
